import { Alert, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Plus, RefreshCw } from 'lucide-react';
import { ROUTES } from '../../routes/routes';
import { SurveyList } from './components';
import { useSurveyList } from './hooks/useSurveyAdminData';

export default function SurveyListPage() {
  const { surveys, isLoading, error, reload } = useSurveyList();

  return (
    <Container fluid className="p-4">
      <div className="d-flex align-items-center justify-content-between mb-3">
        <div>
          <h1 className="h3 mb-1">Surveys</h1>
          <div className="text-muted small">Manage survey definitions, quiz versions, statistics, and answers.</div>
        </div>
        <div className="d-flex gap-2">
          <button className="btn btn-outline-secondary btn-sm" type="button" onClick={() => void reload()}>
            <RefreshCw size={15} className="me-1" />
            Refresh
          </button>
          <Link className="btn btn-primary btn-sm" to={ROUTES.survey.settings('new')}>
            <Plus size={15} className="me-1" />
            New Survey
          </Link>
        </div>
      </div>

      {error && <Alert variant="danger">{error}</Alert>}
      <SurveyList surveys={surveys} isLoading={isLoading} />
    </Container>
  );
}
